<template>
    <div class="datePickerDiv" :class="[selectedOption === 'Select range' ? 'datepickerDivInput' : '', isMobile ? 'mobileDatePicker' : '']">
        <VueDatePicker v-if="isMobile" v-model="dateRange" ref="datepicker" :enable-time-picker="false"
            menu-class-name="dp-custom-menu" :format="format" input-class-name="dp-custom-input" :range="haveRange"
            :disabled-dates="!haveRange ? disabledBeforeToday : disabledAfterToday" :action-row="{ showPreview: false }" @update:model-value="handleDate"
            hide-input-icon :clearable="false" calendar-cell-class-name="dp-custom-cell" @open="openCalendar"
            @closed="closeCalendar" six-weeks :alt-position="customPosition"/>
        <VueDatePicker v-else v-model="dateRange" ref="datepicker" :enable-time-picker="false" placeholder="Custom dates"
            menu-class-name="dp-custom-menu" :format="format" input-class-name="dp-custom-input" :range="haveRange" multi-calendars
            :disabled-dates="!haveRange ? disabledBeforeToday : disabledAfterToday" :action-row="{ showPreview: false }" @update:model-value="handleDate"
            hide-input-icon :clearable="false" calendar-cell-class-name="dp-custom-cell" @open="openCalendar"
            @closed="closeCalendar" six-weeks auto-position />
    </div>
</template>
  
<script>
import { ref, watch, onMounted } from 'vue';
import i18n from 'src/assets/i18n/i18n'
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import { useStore } from 'vuex';
import Misc from 'src/utils/helper/misc'
import { DATE_RANGE_OPTIONS } from 'src/utils/constants/common.js'

export default {
    props: {
        isMobile: {
            type: Boolean,
            default: false
        },
        selectedOption: {
            type: String,
            default: ''
        },
        haveRange: {
            type: Boolean,
            default: true
        }
    },
    emits: ['update:calendar', 'show:select-range', 'show:last-selected', 'close:calendar'],
    components: {
        VueDatePicker
    },
    setup(props, { emit }) {
        const { t } = i18n().global
        const dateRange = ref('')
        const datepicker = ref(null);
        const store = useStore();
        const startDate = ref(null);
        const endDate = ref(null);

        const customPosition = () => ({ top: 12, left: -7});
  
        const disabledAfterToday = (date) => {
            const allTimeDate = new Date(2022, 2, 29);
            const today = new Date();
            today.setHours(23, 59, 59);
            return date < allTimeDate || date > today
        }

        const disabledBeforeToday = (date) => {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            return date <= today;
        }

        const onRangeStart = (date) => {
            startDate.value = date
        }

        const onRangeEnd = (date) => {
            endDate.value = date
        }

        const openCalendar = () => {
           emit('show:select-range')
        }

        const closeCalendar = () => {
            emit('show:last-selected')
            emit('close:calendar');
        }


        const convertDate = (dateValue, from) => {
            dateValue = Array.isArray(dateValue) ? dateValue : [dateValue];
            let fromDate = Misc.formatDate(new Date(dateValue[0]), 'en', 'YYYY-MM-DD')
            let toDate = ''
            let dropdownstartDate = Misc.formatDate(new Date(dateValue[0]), 'en', 'MMM DD, YYYY')
            let dropdownendDate = ''
            if (!dateValue[1]) {
                dropdownendDate = dropdownstartDate
                toDate = fromDate
            } else {
                dropdownendDate = Misc.formatDate(new Date(dateValue[1]), 'en', 'MMM DD, YYYY')
                toDate = Misc.formatDate(new Date(dateValue[1]), 'en', 'YYYY-MM-DD')
            }
            if (startDate.value > endDate.value) {
                let dateObj = dropdownstartDate;
                let dateStartObj = fromDate;
                fromDate = toDate;
                toDate = dateStartObj;
                dropdownstartDate = dropdownendDate;
                dropdownendDate = dateObj;
            }

            if (from === 'handleDate') {
                return {
                    dropdownstartDate,
                    dropdownendDate,
                    fromDate,
                    toDate
                }
            }

            if (from === 'format') {
                return {
                    dropdownstartDate,
                    dropdownendDate 
                }
            }
        }

        const handleDate = (dateValue) => {
            if (!dateValue) return;
            let returnDateObj = convertDate(dateValue, 'handleDate')
            const { dropdownstartDate, dropdownendDate, fromDate, toDate } = returnDateObj

            if (dropdownstartDate < dropdownendDate || dropdownstartDate > dropdownendDate) {
                emit('update:calendar', { startDate: fromDate, endDate: toDate, selected: `${dropdownstartDate} - ${dropdownendDate}` })
            } else {
                emit('update:calendar', { startDate: fromDate, endDate: toDate, selected: `${dropdownstartDate}` })
            }
        }

        const format = (dateValue) => {
            if (!dateValue) return;
            let returnDateObj = convertDate(dateValue, 'format')
            const { dropdownstartDate, dropdownendDate } = returnDateObj

            if (dropdownstartDate < dropdownendDate || dropdownstartDate > dropdownendDate) {
                store.commit('salesReport/setDateRangeDropdown', `${dropdownstartDate} - ${dropdownendDate}`)
                return `${dropdownstartDate} - ${dropdownendDate}`
            } else {
                store.commit('salesReport/setDateRangeDropdown', `${dropdownstartDate}`)
                return `${dropdownstartDate}`
            }
        }

        watch(
            () => props.selectedOption,
            (newValue) => {
                let value = DATE_RANGE_OPTIONS.find(option => t(`pages.dashboard.components.dateSelectDropdown.${option.label}`) === newValue)
                if (newValue && newValue !== 'Select range' && value) {
                    datepicker.value.clearValue()
                }
            }
        )

        onMounted(() => {
            if (props.isMobile) {
                datepicker.value.openMenu()
            }
        })
        return {
            dateRange,
            datepicker,
            startDate,
            endDate,
            closeCalendar,
            openCalendar,
            convertDate,
            handleDate,
            onRangeStart,
            onRangeEnd,
            format,
            disabledAfterToday,
            disabledBeforeToday,
            customPosition
        }
    }
}
</script>
  
<style lang="scss">
@import 'mpl-css/lib/assets/global/variables/fonts.scss';
@import 'mpl-css/lib/assets/global/functions/index.scss';
@import 'mpl-css/lib/assets/global/variables/breakpoints.scss';
@import 'mpl-css/lib/assets/global/functions/index';

.mobileDatePicker {
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;
    position: relative;
    background-color: #fff;
    height: 450px;
    padding: 24px;
    left: 0;

    .dp-custom-menu {
        border: 0;
        width: rem(390)!important;

        .dp-custom-cell {
            border-radius: 8px;
        }

        .dp__calendar_header {
            margin-top: rem(16);
        }

        @media screen and (max-width: 390px) {
            width: rem(358)!important;
        }
        @media screen and (max-width: 375px) {
            width: rem(350)!important;
        }
        @media screen and (max-width: 360px) {
            width: rem(324)!important;
        }

        @media screen and (max-width: map-get($breakpoints, 'xs')) {
            width: rem(290)!important;
        }

        .dp__menu {
            width: rem(400);
        }

        .dp__arrow_top {
            display: none;
        }
        .dp__action_row {
            
            .dp__action_buttons {
                justify-content: flex-start;
                margin-inline-start: unset;
                margin-top: -10px;
                button {
                    padding: rem(12) rem(16);
                }
            }
        }
    }
}

.datePickerDiv {
    width: 100%;

    .dp-custom-input {
        border: 0;
        background-color: transparent;
        font-family: $mt-medium;
        font-weight: 500;
        font-size: 0.8125rem;
        line-height: 1rem;
        color: #fff;
        padding-left: rem(0);
        padding-right: rem(16); 

        &::placeholder {
            font-family: $mt-medium;
            font-weight: 500;
            font-size: 0.8125rem;
            line-height: 1rem;
            color: #1E242C;
            opacity: 1;
        }

        &:hover {
            border-color: transparent;
        }
    }

    .dp-custom-menu {
        border-radius: 8px;
        font-weight: normal;

        .dp-custom-cell {
            font-weight: normal;
        }
    }
}

.datepickerDivInput {
    .dp-custom-input {

        &::placeholder {
            color: #fff;
        }
    }
}
</style>
  